import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_MERCHANDISE_BY_ID } from 'actions/apiActionConstants'
import getMerchandiseById from 'api/merchandise/getMerchandiseById'
import { SHOULD_AUTOBATCH } from '@reduxjs/toolkit'

function fetchMerchandiseById(id: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (state.merchandise.merchandise[id] ||
      state.merchandise.fetchingMerchandise[id] ||
      state.merchandise.merchandiseErrors[id]
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_BY_ID,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
      request: () => getMerchandiseById(id),
      id,
    })
  }
}

export default fetchMerchandiseById
